import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { basket_req, getFeautered_req, getProductsItem_req } from "../api/api";
import { useDispatch, useSelector } from "react-redux";
import Head from "next/head";
import { useIntl } from "react-intl";

import Page from '../components/Page'
import Title from "../elements/title";
import ProductItem from "../components/productItem";
import AsNavFor from "../components/slider";

import { addRemoveFromBasket } from "../helpers/basket.helper";
import { getCookie } from "../helpers/cookie.helpers";
import { changeBasketCount } from "../redux/global.slice";
import Breadcrumbs from "../components/Breadcrumbs";

const Product = (query) => {
    const dispatch = useDispatch();
    const router = useRouter();

    const intl = useIntl();

    const basketCount = useSelector((state) => state.global.basket);
    const [favoriteData, setFavoriteData] = useState(null);
    const [productImages, setProductImages] = useState(null);
    const [sizeData, setSizeData] = useState(null);
    const [basketData, setBasketData] = useState(null);
    const [addBasketBtn, setAddBasketBtn] = useState(false);
    const locale = useSelector((state) => state.global.locale);
    const [productItem, setProductItem] = useState(null);
    const [coockieData, setCoockieData] = useState(null);
    const [count, setCount] = useState(1);

    const productItemReq = async () => {
        const productData = await getProductsItem_req(query.id);
        if (productData) {
            setProductImages(
                productData?.product?.images
                    ? JSON.parse(productData?.product?.images)
                    : null
            );
            setSizeData(JSON.parse(productData?.product?.size));
        }
        setProductItem(productData);
    };

    const basketDataReq = async () => {
        try {
            const basketReq = await basket_req(basketCount);

            const data = getCookie("basket");

            setBasketData(basketReq);
            if (basketReq) {
                dispatch(changeBasketCount(data?.length));
            }
        } catch (e) { }
    };

    useEffect(() => {
        if (basketCount?.length > 0) {
            basketDataReq();
        }
    }, [basketCount]);
    useEffect(() => {
        const data = getCookie("productsCount");
        setCoockieData(JSON.parse(data));
    }, []);
    useEffect(() => {
        setAddBasketBtn(false);
        setCount(1);
    }, [query]);

    const countData = coockieData && coockieData[productItem?.product?.id];

    let favoriteProducts = productItem?.favoriteProducts;
    const producted = productItem?.product;

    // const totalCount = count * producted?.price;
    const countObj = [];
    const featuredProductsReq = async () => {
        const response = await getFeautered_req();
        setFavoriteData(response?.data);
    };
    useEffect(() => {
        productItemReq();
        featuredProductsReq();
    }, [query.id, locale]);

    const plusCount = async (count) => {
        setCount(count);
        const id = producted?.id;
        const dataCount = localStorage.getItem(countObj);

        if (dataCount === null) {
            countObj.push({ id, count });
        } else {
            countObj.push([...dataCount, { id, count }]);
        }

        localStorage.setItem("countObj", JSON.stringify(...countObj));

        // dispatch(
        //   changeCountForProduct({
        //     productId: producted?.id,
        //   })
        // );
    };

    const minusCount = (count) => {
        if (count > 1) {
            setCount(count);
        } else {
            setCount(1);
        }
    };
    const updateProductPage = (id) => {
        setCount(1);
        setAddBasketBtn(false);
        router.push(`/product?&id=${id}`);
    };

    const addBasket = (id, count) => {
        basketDataReq();
        setAddBasketBtn(!addBasketBtn);
        addRemoveFromBasket(
            id,
            count,
            intl.messages.product_successfully_added,
            intl.messages.product_successfully_removed
        );
    };

    const dataFilterProducts = basketData?.find((item) => item.id == query.id);

    const productPrice = count * producted?.price;

    const discountPrice = (productPrice * 10) / 100;
    const priceDiscount = productPrice - discountPrice;

    return producted ? (
        <Page meta={{
            title: producted?.title,
            description: producted?.description,
            image: productImages?.[0]?.image
        }}
            jsonLd={{
                "@context": "https://schema.org/",
                "@type": "Product",
                name: producted?.title,
                description: producted?.description,
                image: productImages?.map(item => item.image),
            }}>
            <Head>
                <link
                    rel="stylesheet"
                    type="text/css"
                    charSet="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
            </Head>
            <div className="product">
                <div className="wrapper">
                    <Breadcrumbs currentPage={producted?.title} className="product-page" />
                    <div className="product-content flex">
                        <div className="product-gallery">
                            <AsNavFor productImages={productImages} />
                        </div>
                        <div className="product-info">
                            <div className="code">
                                {intl.messages.code}: {producted?.code}
                            </div>
                            <div className="name">{producted?.title}</div>
                            <ul>
                                {sizeData?.[0]?.name && (
                                    <li>
                                        <span>{intl.messages.size}:</span>
                                        <strong>{sizeData?.[0]?.name}</strong>
                                    </li>
                                )}

                                {producted?.weight && (
                                    <li>
                                        <span>{intl.messages.weight}:</span>
                                        <strong>
                                            {producted?.weight} {intl.messages.kg}
                                        </strong>
                                    </li>
                                )}
                                {producted?.title && (
                                    <li>
                                        <span>{intl.messages.category}:</span>
                                        <strong>{producted?.categoryList?.[0].name}</strong>
                                    </li>
                                )}
                            </ul>
                            <div className="description">{producted?.description}</div>
                            <div className="flex mb-60">
                                <div className="count">
                                    <div className="field-name">{intl.messages.quantity}</div>
                                    <div className="quantity">
                                        {dataFilterProducts || addBasketBtn ? null : (
                                            <span onClick={() => minusCount(count - 1)}>-</span>
                                        )}

                                        <div className="quantity-number">
                                            {countData ? countData : count}
                                        </div>
                                        {dataFilterProducts || addBasketBtn ? null : (
                                            <span onClick={() => plusCount(count + 1)}>+</span>
                                        )}
                                    </div>
                                </div>
                                <div className="price">
                                    <div className="field-name">{intl.messages.price}</div>
                                    <span>
                                        {count > 4 ? (
                                            <>
                                                <b className="old-price">
                                                    {productPrice} {producted?.currency}
                                                </b>{" "}
                                                <b>
                                                    {priceDiscount} {producted?.currency}
                                                </b>
                                            </>
                                        ) : (
                                            <b>
                                                {productPrice} {producted?.currency}
                                            </b>
                                        )}
                                    </span>
                                </div>
                            </div>

                            {dataFilterProducts ? (
                                <button className="added-basket-button">
                                    {intl.messages.productAdded}
                                </button>
                            ) : (
                                <button
                                    className="add-basket-button"
                                    onClick={() => addBasket(producted?.id, count)}
                                >
                                    {intl.messages.addBasket}
                                </button>
                            )}
                            <div className="text-info">
                                * {intl.messages.discount_text}
                            </div>
                        </div>
                    </div>
                    <div className="products pt-40 pb-40">
                        <Title title={intl.messages.favoriteProducts} />
                        <div className="flex flex-wrap">
                            {favoriteData?.featuredProducts?.map((item) => (
                                <ProductItem
                                    key={item.id}
                                    image={item.image}
                                    name={item.title}
                                    size={item.size}
                                    price={item.price}
                                    code={item.code}
                                    categoryName={item.categoryName}
                                    tag={item?.discount}
                                    oldPriceData={true}
                                    id={item.id}
                                    currency={item.currency}
                                    updateProductPage={updateProductPage}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    ) : null;
};

Product.getInitialProps = ({ query }) => {
    return query;
};

export default Product;
